// TECH-74: the shopper's picked sizes, remembered per browser. The cart writes
// it on a confirmed add-to-bag; search reads it to surface items in her size.
// Neutral module so neither side depends on the other. The durable, cross-device
// size/fit profile is backend-owned - this is the www stopgap.
const PREFERRED_SIZES_KEY = 'preferred-sizes'
const MAX_PREFERRED_SIZES = 4

const normalize = (size) =>
  String(size || '')
    .trim()
    .toUpperCase()

// Sizes the shopper has picked, most recent first ([] when none / unavailable).
export const getPreferredSizes = () => {
  if (typeof window === 'undefined') {
    return []
  }
  try {
    const raw = window.localStorage.getItem(PREFERRED_SIZES_KEY)
    return raw ? JSON.parse(raw).map(normalize).filter(Boolean) : []
  } catch (e) {
    return []
  }
}

// Remember a size the shopper picked (deduped, most-recent-first, capped).
// Best-effort: a private-mode / blocked localStorage just leaves it off.
export const rememberPreferredSize = (size) => {
  const next = normalize(size)
  if (!next || typeof window === 'undefined') {
    return
  }
  try {
    const current = getPreferredSizes().filter((item) => item !== next)
    window.localStorage.setItem(
      PREFERRED_SIZES_KEY,
      JSON.stringify([next, ...current].slice(0, MAX_PREFERRED_SIZES)),
    )
  } catch (e) {
    // localStorage unavailable - personalization simply stays off
  }
}
